import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { CommonService } from "src/app/services/common.service";
import { LazyLoadEvent } from "primeng/api";
import { CategoryService } from "../../../services/category.service";
import { SubscribeService } from "src/app/frontend/service/subscribeService.service";

import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { RoleService } from "src/app/services/role.service";
@Component({
  selector: "app-contest-leaderboard-result",
  templateUrl: "./leaderboard.component.html",
  styleUrls: ["./leaderboard.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class ContestLeaderboardComponent implements OnInit {
  filtervisible: boolean = false;
  public tournamentId;
  public loggedInAcademy;
  public loggedInAcademyId;
  public isTournamentDrawView: boolean = false;
  public categoryId;
  public ageGroupId;
  public categoryList: any = [];
  public ageGroupList: any = [];
  public catList: any = [];
  public ageList: any = [];
  public selectedCatId;
  public selectedGroupId;
  categoryForm: FormGroup;
  public selectedAgeGroupId;
  public tournamentCategoryId;
  public publishStatus: boolean = true;
  public showPublish: boolean = false;
  public tournamentResult;
  public showEmpty: boolean = false;
  tournamentname: any;
  errorMessage = "";
  totalRecords: 0;
  loading: boolean;
  paginationOption;
  item: any;
  citylist: any = [];
  statelist: any = [];
  countryCode = "IN";
  countryName = "India";
  statecode: any;
  statename: any;
  citycode: any;
  cityname: any;
  public courtTypeList = environment.courtTypeList;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  courttype: any;
  tournamentList: any;
  playerName: string;
  selectedStateOption: any;
  selectedCityOption: any;
  matchAgeQuery;
  pageNumberFirst: any;
  pageLimitFirst: number;
  constructor(
    private activatedRoute: ActivatedRoute,
    private tokenStorageService: TokenStorageService,
    private tournamentService: TournamentsService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private commonService: CommonService,
    private router: Router,
    private categoryService: CategoryService,
    private subscribeService: SubscribeService,
    private roleService: RoleService,
  ) { }

  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute(this.router.url);
    this.activatedRoute.queryParams.subscribe((query)=>{
      if(query['page']) {
        this.pageNumberFirst = query['page'];
      } else {
        this.pageNumberFirst = 1;
      }
      if(query['limit']) {
        this.pageLimitFirst = +query['limit'];
      } else {
        this.pageLimitFirst = 10;
      }
    })
   
    this.tournamentId = this.activatedRoute.snapshot.paramMap.get("id");
    this.loggedInAcademy = this.tokenStorageService.getUser();
    this.paginationOption = environment.pagination;
    this.categoryForm = this.formBuilder.group({
      categoryType: ["", [Validators.required]],
      ageGroup: ["", [Validators.required]],
    });
    let category = this.tournamentService.getCategory();
    if (category != "") {
      this.categoryId = category["categoryId"];
      this.ageGroupId = category["ageGroupId"];
      this.showPublish = true;
    }
    this.getState();
    this.getTournamentCategories();
  }

  onContestLeaderBoardPageChange(event) {
    let pagenumber = 1;
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: pagenumber,limit:rows },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  async getTournamentCategory(event) {
    if (event.value != null) {
      this.tournamentId = event.value.id;
      let query = "getMatchtype=true";
      this.tournamentService
        .getTournamentCategory(this.tournamentId, query)
        .subscribe(
          (data) => {
            if (data) {
              this.categoryList = data.items;
              this.categoryList.forEach((element) => {
                if (element.matchTypeId === this.categoryId) {
                  this.categoryForm.controls.categoryType.setValue(element);
                  let event = {
                    value: {
                      matchTypeId: element.matchTypeId,
                    },
                  };
                  this.onSelectCategory(event);
                }
              });
            }
          },
          (err) => { }
        );
    } else {
      this.tournamentId = "";
      this.selectedGroupId = "";
      this.categoryList = [];
      this.ageGroupList = [];
      this.selectedAgeGroupId = "";
    }
  }

  onSelectCategory(event) {
    if (event.value != null) {
      this.selectedGroupId = event.value.matchTypeId;
      let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
      this.showEmpty = true;
      //this.categoryId='';
      this.tournamentService
        .getTournamentCategory(this.tournamentId, query)
        .subscribe(
          (data) => {
            this.ageGroupList = [];
            this.publishStatus = true;
            if (data) {
              this.ageGroupList = data.items;
              this.ageGroupList.forEach((element) => {
                if (element.ageGroupId === this.ageGroupId) {
                  this.categoryForm.controls.ageGroup.setValue(element);
                  this.publishStatus = element.publishStatus;
                  this.tournamentCategoryId = element.tournamentCategoryId;
                }
              });
            }
          },
          (err) => { }
        );
    } else {
      this.selectedGroupId = "";
      this.ageGroupList = [];
      this.selectedAgeGroupId = null;
    }
  }
  onAgeGroupSelect(event) {
    this.selectedStateOption = null;
    this.selectedCityOption = null;
    this.statecode = null;
    this.statename = "";
    this.citylist = [];
    this.citycode = null;
    if (event.value != null) {
      this.selectedAgeGroupId = event.value.value;
      if (event.value.drawStatus && !event.value.publishStatus) {
        this.showPublish = true;
      } else {
        this.showPublish = false;
      }
      this.publishStatus = event.value.publishStatus;
      this.tournamentCategoryId = event.value.tournamentCategoryId;
      this.tournamentResult = [];
    } else {
      this.selectedAgeGroupId = null
    }
    let query = "&filterByMatchId=" + this.selectedCatId + "&filterByAgegroupId=" + this.selectedAgeGroupId;
    this.subscribeService.fetchPlayerRakingDetails(query);
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  loadLeaderboard(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;

    let query = "filterByDisable=false&filterByPublishStatus=true";
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (this.selectedCatId == null && this.selectedAgeGroupId == null) {
      //params += "&filterByMatchId=" + this.selectedCatId;
      //params += "&filterByAgegroupId=" + this.selectedAgeGroupId;

      if (this.citycode != null) {
        params += "&filterByCitycode=" + this.citycode;
      }
      if (event.filters.global != undefined) {
        params += "&filterByPlayerNameFilter=" + event.filters.global.value;
      }
      if (this.statecode != null) {
        params += "&filterByStatecode=" + this.statecode;
      }
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }

      this.tournamentService.contestLeaderboard(query).subscribe((data) => {
        this.tournamentResult = data["data"]["items"];
        this.totalRecords = data["data"]["totalCount"];
        if (this.tournamentResult.length > 0) {
          this.showEmpty = false;
          let index = 1;
          const rating = this.tournamentResult.forEach((player) => {
            const playerRating = player.playerRating;
            const oldplayerLastRating = player.oldplayerLastRating;
            if (playerRating > oldplayerLastRating) {
              let addition = playerRating - oldplayerLastRating;
              player.difference = addition;
              player.showclass = true;
            } else {
              let subtraction = playerRating - oldplayerLastRating;
              player.difference = subtraction;
              player.showclass = false;
            }
            player.serial = index++;
          });
        }
      });
    }
  }

  getState() {
    this.commonService.getStateList(this.countryCode).subscribe((res) => {
      this.statelist = res.data.items;
    });
  }

  onStateSelect(event) {

    if (event.value != null) {
      this.statecode = event.value.code;
      this.statename = event.value.name;
      this.getCity(this.statecode);
    } else {
      this.statecode = null;
      this.statename = "";
      this.citylist = [];
      this.citycode = null;
    }
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  getCity(statecode) {
    this.commonService.getCityList(statecode).subscribe(
      (data) => {
        this.citylist = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onCitySelect(event) {
    if (event.value != null) {
      this.citycode = event.value.code;
      this.cityname = event.value.name;
    } else {
      this.citycode = "";
      this.cityname = "";
    }
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }
  filterDialog() {
    this.filtervisible = true;
  }

  tournamentCategory=[];
  getTournamentCategories() {
    // let query =
    //   "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament_category";
    // this.categoryService.getCategoryWithoutAuthList(query).subscribe((data) => {
    //   var query =
    //     "?filterByDisable=false&filterByStatus=true&filterByParent=" +
    //     data.data.items[0]["id"] +
    //     "&sortBy=created_at&orderBy=1";
    //   this.categoryService
    //     .getCategoryDetailsWithoutAuthList(query)
    //     .subscribe((data) => {
    //       var catlist = data.data.items;
    //       catlist.forEach((element) => {
    //         let obj = {
    //           label: element.name,
    //           value: element.id,
    //           slug: element.slug,
    //         };
    //         this.catList.push(obj);
    //       });
    //     });
    // });    
    this.tournamentService.gettournamentLeaderCategory().subscribe((data) => {
      //console.log(data['items']);
      this.tournamentCategory = data['items'];
      var catlist = data['items'];
      catlist.forEach((element) => {        
        let obj = {
          label: element.matchName[0].name,
          value: element.matchName[0]._id,
          slug: element.matchName[0].slug,
        };
        this.catList.push(obj);
      });
      
    });
  }

  onselectGetCategory(event) {
    this.selectedStateOption = null;
    this.selectedCityOption = null;
    this.statecode = null;
    this.statename = "";
    this.citylist = [];
    this.citycode = null;
    this.ageList = [];
    this.categoryForm.controls.ageGroup.reset();
    if (event.value != null) {
      this.selectedCatId = event.value.value;      
      let index = this.findIndexById(this.selectedCatId, this.tournamentCategory);
      let agegrouplist=this.tournamentCategory[index];
      //agegrouplist
      this.ageList=[];
      agegrouplist['ageGroupData'].forEach((element) => {      
        console.log(element);  
        let obj = {
          label: element.name,
          value: element._id,
          slug: element.slug,
        };
        this.ageList.push(obj);
      });     
    } else {
      this.ageList = [];
      this.selectedCatId = null;

    }
    //this.loadLeaderboard(this.lastTableLazyLoadEvent);
    this.tournamentResult = [];


  }
  findIndexById(id, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      console.log(array[i]['_id']['matchTypeId']+"  "+id);
      if (array[i]['_id']['matchTypeId']=== id) {
        index = i;
        break;
      }
    }
    return index;
  }
  showUserdetails(userId) {
    //this.router.navigate(['/player-details/' + userId], { queryParams: { filterByMatchId: this.selectedCatId, filterByAgegroupId: this.selectedAgeGroupId}});
    this.router.navigate(['/contest-player-details/' + userId],{ queryParams: { page: 1, limit: 10}});
  }

  showUserProfile(userId) {
    //this.router.navigate(['/player-details/' + userId], { queryParams: { filterByMatchId: this.selectedCatId, filterByAgegroupId: this.selectedAgeGroupId}});
    let query = "";
    this.subscribeService.fetchPlayerRakingDetails(query);
    this.router.navigate(['/contest-player-details/' + userId],{ queryParams: { page: 1, limit: 10}});
  }
}
